"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addRecentlyViewedApi = exports.getRecentlyViewedApi = exports.removeSavePropertyiesByPropertyIdsApi = exports.addSavePropertiesApi = exports.getSavePropertyIdsApi = exports.getSavePropertiesApi = exports.getPropertiesDetailByIdsApi = void 0;
var effects_1 = require("redux-saga/effects");
var EnqueueTokenSaga_1 = require("@/pages/common/sagas/EnqueueTokenSaga");
var stateFilter_1 = require("@/pages/common/sagas/stateFilter");
var FavApiToken_1 = require("@/api/remote/protected/FavApiToken");
var getPropertiesDetailByIdsApi = function (ids) {
    var currencyKey, languageCode;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(stateFilter_1.getCurrentCurrency)];
            case 1:
                currencyKey = _a.sent();
                return [4 /*yield*/, effects_1.select(stateFilter_1.getCurrentLanguageCode)];
            case 2:
                languageCode = _a.sent();
                return [4 /*yield*/, effects_1.call(EnqueueTokenSaga_1.enqueueToken, FavApiToken_1.getPropertiesDetailApiToken, ids, currencyKey, languageCode)];
            case 3: return [2 /*return*/, _a.sent()];
        }
    });
};
exports.getPropertiesDetailByIdsApi = getPropertiesDetailByIdsApi;
var getSavePropertiesApi = function (page, pageSize) {
    var currencyKey, langCode, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(stateFilter_1.getCurrentCurrency)];
            case 1:
                currencyKey = _a.sent();
                return [4 /*yield*/, effects_1.select(stateFilter_1.getCurrentLanguageCode)];
            case 2:
                langCode = _a.sent();
                return [4 /*yield*/, effects_1.call(EnqueueTokenSaga_1.enqueueToken, FavApiToken_1.getFavsApiToken, currencyKey, langCode, page, pageSize)];
            case 3:
                response = _a.sent();
                if (!response || !response.data || !response.data.properties)
                    return [2 /*return*/, { pager: { currentPage: 0, totalItems: 0, totalPages: 0 }, properties: [] }];
                return [2 /*return*/, response.data];
        }
    });
};
exports.getSavePropertiesApi = getSavePropertiesApi;
var getSavePropertyIdsApi = function () {
    var currencyKey, langCode, response;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, effects_1.select(stateFilter_1.getCurrentCurrency)];
            case 1:
                currencyKey = _c.sent();
                return [4 /*yield*/, effects_1.select(stateFilter_1.getCurrentLanguageCode)];
            case 2:
                langCode = _c.sent();
                return [4 /*yield*/, effects_1.call(EnqueueTokenSaga_1.enqueueToken, FavApiToken_1.getFavsApiToken, currencyKey, langCode, 1, 1000)];
            case 3:
                response = _c.sent();
                return [2 /*return*/, ((_b = (_a = response) === null || _a === void 0 ? void 0 : _a.data.properties) === null || _b === void 0 ? void 0 : _b.map(function (it) { return Number(it.propertyListingId); })) || []];
        }
    });
};
exports.getSavePropertyIdsApi = getSavePropertyIdsApi;
var addSavePropertiesApi = function (saveSets) {
    var languageCode, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(stateFilter_1.getCurrentLanguageCode)];
            case 1:
                languageCode = _a.sent();
                return [4 /*yield*/, effects_1.call(EnqueueTokenSaga_1.enqueueToken, FavApiToken_1.addFavApiToken, saveSets, languageCode)];
            case 2:
                response = _a.sent();
                return [2 /*return*/, response];
        }
    });
};
exports.addSavePropertiesApi = addSavePropertiesApi;
var removeSavePropertyiesByPropertyIdsApi = function (propertyIds) {
    var languageCode, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(stateFilter_1.getCurrentLanguageCode)];
            case 1:
                languageCode = _a.sent();
                return [4 /*yield*/, effects_1.call(EnqueueTokenSaga_1.enqueueToken, FavApiToken_1.removeFavByPropertyIdsApiToken, propertyIds, languageCode)];
            case 2:
                response = _a.sent();
                return [2 /*return*/, response];
        }
    });
};
exports.removeSavePropertyiesByPropertyIdsApi = removeSavePropertyiesByPropertyIdsApi;
var getRecentlyViewedApi = function (page) {
    var PAGE_SIZE, currencyKey, langCode, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                PAGE_SIZE = 12;
                return [4 /*yield*/, effects_1.select(stateFilter_1.getCurrentCurrency)];
            case 1:
                currencyKey = _a.sent();
                return [4 /*yield*/, effects_1.select(stateFilter_1.getCurrentLanguageCode)];
            case 2:
                langCode = _a.sent();
                return [4 /*yield*/, effects_1.call(EnqueueTokenSaga_1.enqueueToken, FavApiToken_1.getRecentlyViewApiToken, currencyKey, langCode, page, PAGE_SIZE)];
            case 3:
                response = _a.sent();
                if (!response || !response.data || !response.data.properties)
                    return [2 /*return*/, { pager: { currentPage: 0, totalItems: 0, totalPages: 0 }, properties: [] }];
                return [2 /*return*/, response.data];
        }
    });
};
exports.getRecentlyViewedApi = getRecentlyViewedApi;
var addRecentlyViewedApi = function (saveSets) {
    var languageCode, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(stateFilter_1.getCurrentLanguageCode)];
            case 1:
                languageCode = _a.sent();
                return [4 /*yield*/, effects_1.call(EnqueueTokenSaga_1.enqueueToken, FavApiToken_1.addRecentlyViewApiToken, saveSets, languageCode)];
            case 2:
                response = _a.sent();
                return [2 /*return*/, response];
        }
    });
};
exports.addRecentlyViewedApi = addRecentlyViewedApi;
